import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { saveToken } from '../redux/UserDataSlice';

const AutoLogout = () => {
  const timeoutId = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logoutUser = () => {
    dispatch(saveToken(''));
    localStorage.removeItem('accessToken');
    localStorage.removeItem('lastActivity');
    navigate('/');
  };

  const resetTimer = () => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    timeoutId.current = setTimeout(() => {
      logoutUser();
    }, 4 * 60 * 1000);
  };

  const handleActivity = () => {
    localStorage.setItem('lastActivity', Date.now().toString());
    resetTimer();
  };

  const checkLastActivityOnLoad = () => {
    const lastActivity = localStorage.getItem('lastActivity');
    const now = Date.now();

    if (lastActivity && now - parseInt(lastActivity, 10) > 4 * 60 * 1000) {
      logoutUser(); 
    } else {
      resetTimer();
    }
  };

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];

    checkLastActivityOnLoad();

    events.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, []);

  return null;
};

export default AutoLogout;
